<template>
  <div class="ScrollVideo" :style="{height: height + 'px'}">

    <video width="640" height="480" ref="vidEl" class="videoEl" playsinline>
      <source :src="vid" type="video/mp4">
        Your browser does not support the video tag.
    </video>

    <h3>En video</h3>
    {{timeCurrent}} {{timeTarget}} {{height}}

  </div>
</template>

<script>

//import ScrollVideo from '@assets/components/ScrollVideo.vue'
import { eventBus } from '@/utils'

export default {
  name: 'ScrollVideo',
  props: {
    filename: String
  },
  data: function () {
    return {
      height: Number,
      offsetTop: Number,
      timeTarget: Number,
      timeCurrent: Number
    }
  },
  computed: {
    vid: function () {
      return require('@/assets/' + this.filename)
    },
    refs: function () {
      return this.$refs
    }
  },
  methods: {
    setCallbacks: function () {
      this.$refs.vidEl.ondurationchange = this.calcHeight;
      this.$refs.vidEl.ontimeupdate = this.onTimeUpdate;
    },
    calcHeight: function () {
      this.height = this.$refs.vidEl.height + this.$refs.vidEl.duration * 1000
    },
    onScroll: function (scrollTop) {
      this.timeTarget = this.$refs.vidEl.offsetTop / 1000;
      if(this.timeTarget > this.$refs.vidEl.currentTime && !this.$refs.vidEl.ended){
        this.$refs.vidEl.play()
      }
      else{
        this.$refs.vidEl.currentTime = this.timeTarget;
      }
      /*this.$refs.vidEl.playbackRate	= this.timeTarget > this.$refs.vidEl.currentTime ? 1 : -1;
      ;*/


    },
    onTimeUpdate: function () {
      this.timeCurrent = this.$refs.vidEl.currentTime
      if(
      (this.$refs.vidEl.playbackRate > 0 && this.$refs.vidEl.currentTime >= this.timeTarget) ||
      (this.$refs.vidEl.playbackRate < 0 && this.$refs.vidEl.currentTime <= this.timeTarget)){
        this.$refs.vidEl.pause();
      }
    }
  },
  created: function () {
    eventBus.$on('scroll',(e) => {
       this.onScroll(e.srcElement.scrollTop)
    });
  },
  mounted: function () {
    this.$refs.vidEl.playbackRate = 1;
    this.setCallbacks();
    this.offsetTop = this.$refs.vidEl.offsetTop
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.ScrollVideo{
  position: relative;
    background: red;
}

.videoEl{
  position: sticky;
  top: 0;
}

video{
  display: inline;
  max-width: 100%;
}

</style>
